<div class="container-fluid container--fixed-available-viewport-height" data-testid="sleep-analysis">
  <div class="row justify-content-md-center" *ngIf="analysisLoadingInProgress">
    <div data-testid="analysis-loading-indicator">
      <loading-indicator></loading-indicator>
    </div>
  </div>

  <div class="row h-100" *ngIf="sleepAnalysis">
    <div class="h-100 overflow-auto col-md-6 col-md">
      <div>
        <div class="row">
          <div class="col-9 row pb-4">

            <div
              class="w-100"
              *ngFor="let entry of [
                { label: 'uploadFormLabelCode', value: sleepAnalysis.code },
                { label: 'labelHospitalName', value: sleepAnalysis.hospitalName },
                { label: 'reportUniqueIdLabel', value: sleepAnalysis.uniqueId },
              ]"
            >
              <span class="strong ps-4">{{ entry.label | localize }}:</span>
              <span class="ps-2">{{ entry.value }}</span>
            </div>

          </div>
        </div>

        <div *ngIf="sleepFindingsFormConfig">
          <form class="container form-striped">
            <form-field [config]="sleepFindingsFormConfig.findings"></form-field>
            <div class="text-end mt-2">
              <button
                type="button"
                class="btn btn-secondary"
                data-testid="generate-findings-button"
                (click)="onGenerateFindingsButtonClick()"
              >{{ "analysisButtonGenerateFindings" | localize }}</button>
            </div>
            <form-field [config]="sleepFindingsFormConfig.conclusion"></form-field>
          </form>

          <div class="pt-2">
            <action-button
              type="button"
              class="btn btn-link mt-2"
              [buttonLabel]="'analysisButtonPreviewReport'"
              [testId]="'preview-button'"
              [actionInProgress]="previewInProgress"
              (click)="onPreviewButtonClick()"
            ></action-button>
          </div>

          <div class="pt-4">
            <action-button
              class="me-4"
              buttonClass="btn btn-outline-primary"
              [buttonLabel]="'analysisButtonSave'"
              [actionInProgressLabel]="'analysisLabelSaveInProgress'"
              [actionInProgress]="saveInProgress"
              [testId]="'save-analysis-button'"
              (buttonClick)="onSaveButtonClick()"
            ></action-button>

            <app-pre-confirm-action-button
              [buttonClass]="'btn btn-primary'"
              [buttonLabel]="'analysisLabelButtonFinish'"
              [confirmationLabel]="'analysisLabelButtonFinishConfirm'"
              [actionInProgressLabel]="'analysisLabelButtonFinishInProgress'"
              [buttonState]="finishButtonState"
              [testId]="'finish-analysis-button'"
              (buttonClick)="onFinishButtonClick()"
            ></app-pre-confirm-action-button>

            <span
              *ngIf="!!errorMessage"
              data-testid="analysis-error-message"
              class="alert alert-danger ms-4"
            >{{ errorMessage | localize }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="h-100 overflow-auto col-md-6 col-md" *ngIf="patientDataFields">
      <div
        data-testid="patient-data-panel"
        class="col-12 small form-grid form-grid-striped"
      >
        <div>
          <div class="row">
            <app-form-field-display
              class="col-12"
              [formFieldConfig]="patientDataFields.reasonForStudy"
              [displayHorizontal]="false"
            ></app-form-field-display>
          </div>
          <app-basic-patient-data-display [patientDataFields]="patientDataFields"></app-basic-patient-data-display>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.overweight"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.profession"
            ></app-form-field-display>
          </div>
        </div>

        <hr/>

        <div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.hypertension"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.diabetes"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.overbite"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.cloggedNasalPassage"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.allergicRhinitis"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.smallChin"
            ></app-form-field-display>
          </div>
        </div>

        <hr/>

        <div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.smoking"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.useOfSleepingPills"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.alcoholConsumption"
            ></app-form-field-display>
          </div>
        </div>

        <hr/>

        <div>
          <p class="strong mb-0">{{ patientDataFields.frequencyHeaderLabel | localize }}</p>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.morningHeadaches"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.breathingLoss"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.fluttering"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.snoring"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.restlessSleep"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.daytimeSleepiness"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.dryMouthInMorning"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.needToUrinate"
            ></app-form-field-display>
          </div>
        </div>

        <hr/>

        <div>
          <p class="strong mb-0">{{ patientDataFields.probabilityHeaderLabel | localize }}</p>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.sittingReading"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.watchingTelevision"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.sittingPassive"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.travelInCarForAnHour"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.lyingDownInAfternoon"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.sittingTalkingToSomeone"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.sitInPeaceAfterNonAlcoholicLunch"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.sitInCarAfterItHasStoppedForFewMinutes"
            ></app-form-field-display>
          </div>
        </div>

        <hr/>

        <div>
          <div class="row">
            <app-form-field-display
              class="col-12"
              [formFieldConfig]="patientDataFields.currentMedication"
              [displayHorizontal]="false"
            ></app-form-field-display>
          </div>
        </div>

        <hr/>

        <div>
          <p class="strong mb-0">{{ patientDataFields.eventsDuringMeasurementLabel | localize }}</p>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.sleepQuality"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.fallingAsleepDuration"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.sleepHours"
            ></app-form-field-display>
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.minutesAwakeAfterMeasurementStart"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              class="col-6"
              [formFieldConfig]="patientDataFields.awakeningsDuringMeasurement"
            ></app-form-field-display>
          </div>
        </div>

        <hr/>

        <div>
          <div class="row">
            <app-form-field-display
              class="col-12"
              [formFieldConfig]="patientDataFields.sleepDiary"
              [displayHorizontal]="false"
            ></app-form-field-display>
          </div>
          <div class="row">
            <app-form-field-display
              class="col-12"
              [formFieldConfig]="patientDataFields.patientFeedback"
              [displayHorizontal]="false"
            ></app-form-field-display>
          </div>
        </div>
      </div>

      <ng-container *ngIf="sleepAnalysis.sleepExternalFindings">
        <hr/>

        <app-sleep-measurements
          [measurements]="sleepAnalysis.sleepExternalFindings.measurements"
          [reportLanguage]="sleepAnalysis.reportLanguage"
        ></app-sleep-measurements>

        <div data-testid="sleep-images">
          <img
            *ngIf="sleepAnalysis.sleepExternalFindings.images.oxygenSaturationTrend as oxygenSaturationTrend"
            class="w-100 my-2"
            [src]="'data:image/png;base64,' + oxygenSaturationTrend"
          />
          <div *ngFor="let sampleImage of sleepAnalysis.sleepExternalFindings.images.sampleImages; let index = index" class="my-2">
            <label>
              <input
                type="checkbox"
                [checked]="!excludedSampleImages.has(sampleImage)"
                (change)="onToggleSampleInclusion(sampleImage)"
                [attr.data-testid]="'include-sample-checkbox-' + index"/>
              {{ "analysisLabelIncludeSampleInReport" | localize }}
            </label>
            <img
              class="w-100"
              [src]="'data:image/png;base64,' + sampleImage.image"
            />
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
